<template>
  <div>
    <div class="content fc-text-center">
      <div class="fc-bg-fff fc-pad-b-sm">
        <p class="login_title">{{$t('m.Diamonds_title')}}</p>
        <img class="login_logo" src="static/img/logo.png">
        <p class="fc-text-bigabit fc-mar-t fc-pad-lr-biger">{{$t('m.scanLogin')}}</p>
        <div class="fc-relative">
          <div id="qrcode" class="qrcode">
            <img :src="qrcodeUrl" alt="" v-if="qrcodeUrl">
            <div class="fail_mask" @click="getQrcodeInfo()" v-if="qrCodeTimeOut">
              <img class="qrcode_ref_icon" src="static/img/refresh.png">
            </div>
          </div>

        </div>
        <p class="login_tip">{{$t('m.scanTip')}}</p>
        <p class="login_tip">(<span id="scanVersion">{{moreLang.scanVersion}}</span>)</p>
      </div>
      <p class="fc-notice" v-html="moreLang.buyNoticeA"></p>

    </div>
    <p class="fc-notice ask">
      <img src="static/img/question_icon.png" class="fc-icon-sm">
      <a class="" @click="gotoask">{{$t('m.common-problem')}}</a>
    </p>
  </div>
</template>
<script>
  import Vue from 'vue';
  import QRCode from 'qrcode';
  import {
    Toast
  } from 'vant';
  Vue.use(Toast);
  var _self;
  export default {
    name: 'login',
    data() {
      return {
        token: '',

        isLunxun: true,

        qrcode: '',
        qrcodeUrl: '',
        qrCodeTxt: 'https://www.tadachat.info/x/',
        qrCodeMd5: '',
        timer: null,
        qrCodeTimeOut: false,
        moreLang: {
          "scanVersion": '',
          "buyNoticeA": '',
        },
      }
    },
    watch: {

    },
    filters: {

    },
    mounted() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        icon: 'static/img/loading.gif',
        className: 'loading'
      });
      _self = this;
      _self.qrcodeUrl = '';
      _self.getLang();
      // _self.textSize();
      _self.getMoreLang();
      _self.getQrcodeInfo();


      window.onbeforeunload = function(e) {
        // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
        //Toast('刷新中22...')
        _self.qrcodeUrl = '';
      }


    },
    destroyed() {
      console.log("ending");
      _self.isLunxun = false;
      _self.qrcodeUrl = '';
    },
    methods: {
      gotoask() {
        _self.isLunxun = false;
        _self.$router.push({
          path: '/asks'
        })
      },
      //字体大小
      textSize() {
        ! function(a) {
          function b() {
            var b = g.getBoundingClientRect().width;
            a.rem = (b / 7.5 > 100 ? 100 : (b / 7.5 < 300 / 7.5 ? 300 / 7.5 : b / 7.5)), g.style.fontSize = a.rem +
              "px"
            //a.rem = (b / 7.5), g.style.fontSize = a.rem + "px"
          }
          var g = a.document.documentElement,
            e;
          a.addEventListener("resize", function() {
            clearTimeout(e), e = setTimeout(b, 300)
          }, !1), a.addEventListener("pageshow", function(a) {
            a.persisted && (clearTimeout(e), e = setTimeout(b, 300))
          }, !1), b()
        }(window);
      },
      getLang() {
        var box = document.getElementById("app");
        let language = navigator.language || navigator.browserLanguage;
        if (language == 'ar') {
          box.style.direction = 'rtl';
        } else {
          box.style.direction = 'ltr';
        }
      },
      selCountryConfirm(val, index) {
        //console.log(val);
        _self.currentCountryIndex = index;
        _self.showcountryPicker = false;
      },
      getMoreLang() {
        let str = _self.$i18n.t('m.scanVersion');
        let a = str.replace(/%s/g, '2.5.72');
        document.title = _self.$i18n.t('m.Diamonds_title');
        _self.moreLang = {
          "scanVersion": a,
          "buyNoticeA": _self.$i18n.t('m.buy-notice-a')
        };
      },

      initQrcode(url) {
        QRCode.toDataURL(url, {
            width: 300,
            height: 300,
            type: 'image/jpeg',
            quality: 0.3,
            margin: 1
          })
          .then(url => {
            //console.log(url);
            _self.qrcodeUrl = url;
            _self.qrCodeTimeOut = false;
          })
          .catch(err => { //异常时的处理
            console.error(err)
          })


      },
      getQrcodeInfo() {

        this.$axios({
            method: "post",
            url: "/api/qrcode/generateKey"
          }).then((res) => {
            console.log(res.data); //  处理成功的函数 相当于success
            Toast.clear();
            if (res.data.code == 1) {
              _self.qrCodeMd5 = res.data.result;
              //_self.qrCodeMd5 = Math.random()*1000;
              _self.initQrcode(_self.qrCodeTxt + _self.qrCodeMd5);
              _self.isLunxun = true;
              _self.checkQrcode();
              /* _self.timer = setInterval(function() {
                 _self.checkQrcode();
              }, 1000); */

            }

          })
          .catch((error) => {
            console.log(error) //  错误处理 相当于error
            _self.qrCodeTimeOut = true;
            Toast.clear();
          })
      },
      //检查qrcode是否有效
      checkQrcode() {
        this.$axios({
          method: "post",
          url: "/api/qrcode/polling",
          params: {
            userKey: _self.qrCodeMd5,
          },
        }).then((res) => {
          //console.log(res.data);
          if (res.data.code == 1) {
            switch (res.data.result.type) {
              //0-未扫码 1-未登录 2-已登录 3-已过期
              case 0:
                _self.qrCodeTimeOut = false;
                break;
              case 1:

                break;
              case 2:
                //clearInterval(_self.timer);
                //Toast('已登录');
                _self.isLunxun = false;
                localStorage.setItem("userInfo", JSON.stringify(res.data.result.userChargeInfoVo));
                _self.$router.replace({
                  path: '/'
                })
                break;
              case 3:
                //Toast('已过期');
                _self.isLunxun = false;
                _self.qrCodeTimeOut = true;
                //clearInterval(_self.timer);
                break;
              default:
                break;
            }
            if (_self.isLunxun) {
              setTimeout(function() {
                _self.checkQrcode();
              }, 1000);
            }

          } else {
            _self.isLunxun = false;
            _self.qrCodeTimeOut = true;
          }

        }).catch((error) => {
          console.log(error);
          //clearInterval(_self.timer);
          _self.isLunxun = false;
          _self.qrCodeTimeOut = true;
        })


      },

    },

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/login.vue